import React from 'react'
export function EventOsmWidget(props) {
    const { coordinates: c } = props;
    console.log({c})
    if (!c) {
        return null;
    }
    const latLng = `${c.lat},${c.lng}`;
    if (!latLng) {
        return null;
    }

    const diff =   0.00169247388840;
    const diffL = 0.00044424265118;

    const topLng = c.lng - diff;
    const topLat = c.lat - diffL;
    const bottomLng = c.lng + diff;
    const bottomLat = c.lat + diffL;

    const base = 'https://www.openstreetmap.org/export/embed.html?bbox=';
    const bbox = `${topLng},${topLat},${bottomLng},${bottomLat}`;
    const msep = `&layer=mapnik&`;
    const mark = `marker=${c.lat},${c.lng}`;
    const src = `${base}${bbox}${msep}${mark}`;
    const maplink = `https://www.openstreetmap.org/?mlat=${c.lat}&amp;mlon=${c.lng}#map=19/${c.lat}/${c.lng}`
return <div style={{position:'relative'}}>
<iframe 
    title="osm"
    width="100%" 
    height="300"
    frameborder="0"
    scrolling="no"
    marginheight="0"
    marginwidth="0"
    src={src}
    style={{
        border: '1px solid black',
        marginBottom: 0,
    }}></iframe>
<br/><small style={{position:'absolute',fontSize:'10px',bottom:'-8px'}}>
    <a href={maplink}>View Larger Map</a></small>   
</div>

}
